"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const Fade_1 = __importDefault(require("@mui/material/Fade"));
const mui_1 = require("tss-react/mui");
const core_1 = require("companion-app-components/utils/core");
const investments_svg_1 = __importDefault(require("assets/zero-state-images/investments.svg"));
const ZeroStateView_1 = __importDefault(require("components/ZeroStateView"));
const InvestmentHoldingHeader_1 = __importDefault(require("./InvestmentHoldingHeader"));
const InvestmentHoldingCard_1 = __importDefault(require("./InvestmentHoldingCard"));
const styles_1 = require("../../containers/InvestmentHoldings/styles");
const log = (0, core_1.getLogger)('containers/InvestmentHoldingsPage/index.js');
log.log('loaded');
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const InvestmentHoldingsPage = (props) => {
    const { accountNode, sortedHoldings, uiState, isLoading } = props;
    const { classes } = useStyles();
    const noHoldings = (!sortedHoldings || sortedHoldings.size === 0);
    return (<Grid_1.default container direction="column" justifyContent="space-between" alignItems="center" className={classes.mainGrid} spacing={3}>
      <Grid_1.default item xs={12} sm={12} md={12} className={classes.mainGridRow}>
        <InvestmentHoldingHeader_1.default accountNode={accountNode} sortedHoldings={sortedHoldings}/>
        {isLoading &&
            <div className={classes.loadingStateContainer}>
            <Fade_1.default in={isLoading} style={{
                    transitionDelay: isLoading ? '800ms' : '0ms',
                }} unmountOnExit>
              <CircularProgress_1.default />
            </Fade_1.default>
          </div>}
        {!isLoading && noHoldings &&
            <ZeroStateView_1.default primary="This account has no holdings" icon={investments_svg_1.default}/>}
        {!isLoading && !noHoldings &&
            <InvestmentHoldingCard_1.default key="INVESTMENT" isLoading={isLoading} sortedHoldings={sortedHoldings} uiState={uiState}/>}
      </Grid_1.default>
    </Grid_1.default>);
};
exports.default = InvestmentHoldingsPage;
